import EventEmitter from 'wolfy87-eventemitter';
import Messager from '../../messager';
import MESSAGE_TYPES from '../../../constants/MESSAGE_TYPES';
import { HELP_EVENTS } from '../../../constants/CONTROLLERS_EVENT_TYPES';

export class HelpController extends EventEmitter {
  state: {
    isHidden: boolean;
  };

  constructor() {
    super();

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.state = {
      isHidden: true,
    };
  }

  show() {
    this.state = {
      isHidden: false,
    };
    Messager.send({
      type: MESSAGE_TYPES.CHANGE_HELP_STATE,
      isOpen: true,
    });
    this.emit(HELP_EVENTS.UPDATE, this.state);
  }

  hide() {
    this.state = {
      isHidden: true,
    };
    Messager.send({
      type: MESSAGE_TYPES.CHANGE_HELP_STATE,
      isOpen: false,
    });
    this.emit(HELP_EVENTS.UPDATE, this.state);
  }
}
